import React, { useContext, useState, useEffect } from 'react';
import { SbEditableContent } from 'storyblok-react';
import { Props } from '../types';
import { Teaser, TeaserFields } from './teaser';
import { getTeaserMapping, TeaserPageTypes } from '../../services/compMapping/teasers';
import { PageStateContext } from '../../services';

const teaserMappings = (article, teaserSettings, globalSettings): TeaserFields | null => {
  if (!article) return null;
  return getTeaserMapping(TeaserPageTypes.PRODUCT)(article, teaserSettings, globalSettings);
};

type PageProps = Props<{ body: SbEditableContent[] }>;

export const RocheProductList = ({ blok, getComponent, slot }: PageProps): JSX.Element => {
  const { setPictureCreditsAdditionalData, settings } = useContext(PageStateContext);
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    const teasers = blok.products.map((item) => teaserMappings(item, {}, settings));
    setArticles(teasers);
    setPictureCreditsAdditionalData(teasers);
  }, [blok.products]);

  return (
    <roche-grid layout="12" slot={slot}>
      <roche-headline headline={blok.headline} level={3} />
      <roche-teaser-list>
        <roche-columns center-children={'false'} multiple-rows={true}>
          {articles?.map((article) => (
            // eslint-disable-next-line no-underscore-dangle
            <roche-column key={article._uid} span={4}>
              <Teaser blok={article} getComponent={getComponent} />
            </roche-column>
          ))}
        </roche-columns>
      </roche-teaser-list>
    </roche-grid>
  );
};
